<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      class="form"
      :rules="rules"
    >
      <el-form-item label="员工姓名" prop="companyName">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="员工号" prop="complaint">
        <el-input v-model="form.workNo"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="companyName">
        <el-input v-model="form.mobilePhone"></el-input>
      </el-form-item>
      <el-form-item label="家庭电话" prop="complaint">
        <el-input v-model="form.familyPhone"></el-input>
      </el-form-item>
      <el-form-item label="民族" prop="detailed">
        <el-input v-model="form.nation"></el-input>
      </el-form-item>
      <el-form-item label="服务人员社区地址" prop="detailed">
        <el-input v-model="form.statSheQuId"></el-input>
      </el-form-item>
      <el-form-item label="员工职位" prop="detailed">
        <el-input v-model="form.position"></el-input>
      </el-form-item>
      <el-form-item label="详细地址" prop="detailed">
        <el-input v-model="form.address"></el-input>
      </el-form-item>
      <el-form-item label="服务类型" prop="remarks">
        <el-input t v-model="form.serveType"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="remarks">
        <el-input t v-model="form.idCard"></el-input>
      </el-form-item>
      <el-form-item label="录入时间" prop="remarks">
        <el-input t v-model="form.entryTime"></el-input>
      </el-form-item>
      <el-form-item label="所属机构点" prop="remarks">
        <el-input t v-model="form.serviceStation"></el-input>
      </el-form-item>
      <el-form-item label="二维码" prop="remarks">
        <el-input t v-model="form.photob"></el-input>
      </el-form-item>
      <el-form-item label="评分" prop="remarks">
        <el-input t v-model="form.grade"></el-input>
      </el-form-item>
      <el-form-item label="停用" prop="remarks">
        <el-input t v-model="form.nonUse"></el-input>
      </el-form-item>
      <el-form-item label="出生日期" prop="remarks">
        <el-input t v-model="form.birthday"></el-input>
      </el-form-item>
      <el-form-item label="经度" prop="remarks">
        <el-input t v-model="form.longitude"></el-input>
      </el-form-item>
      <el-form-item label="纬度" prop="remarks">
        <el-input t v-model="form.latitude"></el-input>
      </el-form-item>
      <el-form-item label="上次签到时刻" prop="remarks">
        <el-input t v-model="form.lastSignTime"></el-input>
      </el-form-item>
      <el-form-item label="政府免费的的次数数" prop="remarks">
        <el-input t v-model="form.freeCount"></el-input>
      </el-form-item>
      <el-form-item label="服务组" prop="remarks">
        <el-input t v-model="form.serviceGroup"></el-input>
      </el-form-item>
      <el-form-item label="同步码" prop="remarks">
        <el-input t v-model="form.sysEndCood"></el-input>
      </el-form-item>
      <div class="button" v-if="buttonType == 'add'">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button type="info" @click="cancel">取消</el-button>
      </div>
      <div class="button" v-if="buttonType == 'compile'">
        <el-button type="primary" @click="save">编辑</el-button>
        <el-button type="info" @click="cancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ["buttonType", "row"],
  data() {
    return {
      form: {
        province: "",
      },
      rules: {},
    }
  },
  created() {
    this.form = this.row
  },
}
</script>

<style scoped>
.left {
  width: 45%;
  display: inline-block;
}

.right {
  width: 50%;
  display: inline-block;
  float: right;
}

.form {
  width: 90%;
}

.flex {
  display: flex;
}

.itemSelect {
  width: 30%;
}

.map {
  width: 100%;
  height: 120px;
  background-color: red;
}

.button {
  width: 400px;
  margin: 30px auto 0px;
  display: flex;
  justify-content: space-between;
}

.el-form-item {
  margin-bottom: 20px !important;
}

.el-form-item__label {
  line-height: 20px !important;
}

.el-radio {
  margin: 20px;
}
</style>
